export function flattenDocItems(docNav) {
  return docNav.flatMap((group) => group.items);
}

export function findActiveGroup(docNav, activeId) {
  return docNav.find((group) => group.items.some((item) => item.id === activeId)) ?? null;
}

export function findActiveItem(docNav, activeId) {
  const group = findActiveGroup(docNav, activeId);
  if (!group) return null;
  const item = group.items.find((i) => i.id === activeId);
  return item ? { group, item } : null;
}

export function getPrevNextItems(docNav, activeId) {
  const allItems = flattenDocItems(docNav);
  const idx = allItems.findIndex((i) => i.id === activeId);
  return {
    prev: idx > 0 ? allItems[idx - 1] : null,
    next: idx < allItems.length - 1 ? allItems[idx + 1] : null,
  };
}

export function validateDocConfig(docNav, hasSectionConfig) {
  const missing = [];
  docNav.forEach((group) => {
    group.items.forEach((item) => {
      if (!hasSectionConfig?.(item.id)) {
        missing.push({ groupId: group.id, sectionId: item.id });
      }
    });
  });
  return missing;
}
